import Admin, { Role, hasRole } from '@/models/Admin'
import Disbursement from '@/models/Disbursement'

export default class DisbursementPolicy {
	viewAny(admin: Admin) {
		return true
	}

	view(admin: Admin, disbursement: Disbursement) {
		return true
	}

	create(admin: Admin) {
		return hasRole(admin, [Role.ADMIN, Role.PRODUCT])
	}

	update(admin: Admin, disbursement: Disbursement) {
		return hasRole(admin, [Role.ADMIN, Role.PRODUCT])
	}

	approve(admin: Admin, disbursement?: Disbursement) {
		return hasRole(admin, [Role.ADMIN, Role.PRODUCT, Role.FINANCE])
	}

	restore(admin: Admin, disbursement: Disbursement) {
		return hasRole(admin, [Role.ADMIN, Role.PRODUCT])
	}

	delete(admin: Admin, disbursement: Disbursement) {
		return hasRole(admin, [Role.ADMIN, Role.PRODUCT])
	}

	forceDelete(admin: Admin, disbursement: Disbursement) {
		return hasRole(admin, Role.ADMIN)
	}

	trash(admin: Admin) {
		return hasRole(admin, Role.ADMIN)
	}
}
